module.exports = __webpack_public_path__ + "img/image103.76336d17.png";